var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import Component from '@arco-design/web-react/es/Cascader/cascader';
import { useConfigContext } from '../config-provider';
var Cascader = function (props, ref) {
    var titles = props.titles, _a = props.splitSymbol, splitSymbol = _a === void 0 ? ', ' : _a;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-cascader";
    var newProps = Object.assign({}, props);
    var renderFooterHandler = useCallback(function (level) {
        var _a;
        return (_a = titles === null || titles === void 0 ? void 0 : titles[level]) !== null && _a !== void 0 ? _a : null;
    }, [titles]);
    var renderFormatHandler = useCallback(function (valueShow) { return valueShow.join(splitSymbol); }, [splitSymbol]);
    return (React.createElement("div", { className: prefixCls },
        React.createElement(Component, __assign({ ref: ref }, newProps, { renderFooter: renderFooterHandler, renderFormat: renderFormatHandler }))));
};
export default React.forwardRef(Cascader);
//# sourceMappingURL=index.js.map